<template>
  <div class="modalBooking">
    <div class="modalBooking-bg" @click="close"></div>
    <div class="modalBooking-dialog">
      <div class="modalBooking-content">
        <div class="modalBooking-header">
          <button class="modalBooking-exit" type="button" @click="close">
            <icon-base>
              <IconClose />
            </icon-base>
          </button>
        </div>
        <div class="modalBooking-body">
          <div class="row align-items-center">
            <div class="col-md-5 mb-20">
              <p class="fz--mid">
                Find your ideal workspace
              </p>
              <div class="row">
                <div class="col-12 datepickers">
                  <DateTimePicker
                    ref="startDate"
                    label="When"
                    timeLabel="Start Time"
                    v-model="schedStart"
                    withIcon
                    :handleClearTime="handleClearTime"
                    :timeItems="startTimeItems"
                    :disabledDates="handleDisabledDate"
                    :disabledPreviousMonth="true"
                    :dateOnly="true"
                    :markedDateToday="true"
                  />
                </div>
              </div>
              <div class="row justify-content-end align-items-start">
                <ActionButton
                  label="Search"
                  class="submit-button"
                  @customEvent="handleMakeBookingClick"
                />
              </div>
            </div>
            <div class="col-md-6 offset-md-1 graphic-col">
              <img
                src="@/assets/media/backgrounds/coworkers.svg"
                alt=""
                class="graphic--booking"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import DateTimePicker from "@/components/datetimepicker/DateTimePicker.vue";
import IconClose from "@/components/icons/IconClose";
import axios from "@/helpers/axios";
import { addDays, format } from "date-fns";

export default {
  name: "MakeBookingModal",
  components: {
    IconClose,
    DateTimePicker,
    ActionButton
  },
  props: {
    userId: {
      type: Number,
      default: null
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    startTimeItems() {
      const now = new Date();

      return Array.apply(null, { length: 48 }).map((time, index) => {
        const value = index.toString();
        const option = new Date(
          new Date(this.schedStart || now).setHours(0, index * 30, 0)
        );
        let isDisabled = false;

        return {
          value,
          name: format(option, "h:mm A"),
          disabled: isDisabled
        };
      });
    },
    endTimeItems() {
      return Array.apply(null, { length: 48 }).map((time, index) => {
        const now = new Date();
        now.setHours(now.getHours() + 1);
        const value = index.toString();
        const option = new Date(
          new Date(this.schedEnd || now).setHours(0, index * 30, 0)
        );

        const formattedSchedStart = new Date(this.schedStart);

        const isDisabled =
          option <
          formattedSchedStart.setHours(formattedSchedStart.getHours() + 1);

        return {
          value: value,
          name: format(option, "h:mm A"),
          disabled: isDisabled
        };
      });
    }
  },
  data: () => ({
    categories: [],
    category: null,
    schedStart: null,
    schedEnd: null,
    isEdit: false,
    isAnytime: true,
    schedule: {
      startDate: null
    },
    disabledDates: {},
    isAdmin: false,
    memberId: null
  }),
  watch: {
    schedStart(newSched) {
      const date = new Date(newSched);
      this.schedule.startDate = format(date, "MMMM D, YYYY");
      this.schedEnd = new Date(
        `${format(date, "MMMM D, YYYY")} 11:59 PM`
      ).toISOString();

      this.$refs.startDate.handleDismiss();
    }
  },
  created() {
    const newSchedStart = addDays(new Date(), 1).toISOString();
    const formatDate = format(newSchedStart, "MMM DD, YYYY");

    this.schedEnd = new Date(`${formatDate} 12:00 AM`).toISOString();
    this.schedStart = new Date(`${formatDate} 12:00 AM`).toISOString();
    this.tempDate = new Date(`${formatDate} 12:00 AM`).toISOString();
  },
  mounted() {
    // Sets schedEnd to an hour ahead of schedStart
    if (this.$route.matched[0].name == "admin") {
      this.isAdmin = true;
      this.memberId = this.userId;
    }
  },
  methods: {
    handleDisabledDate(date) {
      return (
        date.getTime() < new Date().getTime() &&
        date.toLocaleDateString() !== new Date().toLocaleDateString()
      );
    },
    formatDate(date, pattern = "MMM DD, YYYY h:mm A") {
      return format(new Date(date), pattern);
    },
    handleClearTime() {
      this.isAnytime = !this.isAnytime;
    },
    paginated(collection, action = "", page = 1) {
      axios
        .get(`/${collection}?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          var { data, meta } = response.data;
          data = data.map(product => ({
            label: product.name,
            value: product.id
          }));
          this[collection] = [...this[collection], ...data];
          if (meta.hasNextPage) {
            this.paginated(collection, action, page + 1);
          }
        });
    },
    handleMakeBookingClick() {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (this.isAdmin) {
        this.$router.push({
          path: `/admin/booking/${this.memberId}`,
          query: {
            startDate: this.schedStart,
            endDate: this.schedEnd,
            timeZone: timeZone,
            anytime: this.isAnytime
          }
        });
      } else {
        this.$router.push({
          name: "UserBookingV3",
          query: {
            startDate: this.schedStart,
            endDate: this.schedEnd,
            timeZone: timeZone,
            anytime: this.isAnytime
          }
        });
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.fz--mid {
  font-family: $font-family-base;
  font-size: 1.625rem;
  line-height: 1.15;
  @media (max-width: 767px) {
    br {
      display: none;
    }
  }
}

.submit-button {
  width: 6.125rem;
  margin-top: 0px;
  margin-right: 15px;
}
.modalBooking {
  display: flex;
  position: fixed;
  z-index: 1001;
  left: 0;
  padding: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden auto;

  @media (min-width: $screen-sm) {
    padding: 0.9375rem;
  }

  &-bg {
    background: black;
    bottom: 0;
    left: 0;
    opacity: 0.5;
    position: fixed;
    right: 0;
    top: 0;
    z-index: -1;
  }

  &-dialog {
    animation: fade-in-up 0.25s ease-out;
    margin: 0;
    max-width: 55rem;
    pointer-events: none;
    position: relative;
    width: 100%;

    @media (min-width: $screen-md) {
      margin: auto;
    }
  }

  &-content {
    background-clip: padding-box;
    background-color: #fff;
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    pointer-events: auto;

    @media (min-width: $screen-sm) {
      border-radius: 5px;
    }
  }

  &-header {
    align-items: flex-start;
    display: flex;
    padding: 1.25rem 2.5rem;
    position: relative;

    &-options {
      flex: 0 1 auto;
      margin-left: auto;
    }
  }

  &-body {
    padding: 0.5rem 2.5rem 4.375rem;
  }

  &-alert {
    background-color: white;
    height: 400px;
    margin: calc(50vh - 200px) 0;

    @media (min-width: $screen-sm) {
      height: 280px;
      width: 500px;
      margin: calc(50% - 140px) calc(50% - 250px) !important;
    }

    @media (min-width: $screen-md) {
      width: 680px;
      margin: calc(50vh - 250px) calc(50% - 340px) !important;
    }
  }

  &-exit {
    background-color: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.625rem;
    margin: 0 -1.5rem 0 auto;
    opacity: 0.5;
    padding: 0.25rem;

    &:hover {
      opacity: 1;
    }
  }

  .datepickers {
    /deep/ .dt-output {
      font-size: 0.875rem;
      white-space: unset;
      padding: 0.625rem 1rem;
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    transform: translateY(5vh);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-select {
  max-width: 270px;
}
</style>
